import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { Trip, TripsSub } from './commonInterfaces';

interface McTripUpdateField {
  table: "Trips" | "Trips_sub" | "",
  id: number,
  custid: number,
  field: string,
  value: any,
  title: string,
  fieldtype: "text" | "yesno" | "noyes" | "number" | "confirmed" | "date" | "rootsLocation" | "staff"

}

@Injectable({
  providedIn: 'root'
})
export class McDataMapService {

  constructor() { }

  readonly fieldData: { [key in keyof (Trip & TripsSub)]?: Partial<McTripUpdateField> } = {
    showTj: {
      table: "Trips",
      field: "showtj",
      fieldtype: "yesno",
      title: "Show Trip Journal?"
    },
    fmsc: {
      table: "Trips",
      field: "fmsc",
      fieldtype: "yesno",
      title: "FMSC?"
    },
    special: {
      table: "Trips",
      field: "special",
      fieldtype: "yesno",
      title: "Vision Trip?"
    },
    leaderTrip: {
      table: "Trips",
      field: "leaderTrip",
      fieldtype: "yesno",
      title: "Leader Trip?"
    },
    leaderMission: {
      table: "Trips",
      field: "leaderMission",
      fieldtype: "yesno",
      title: "Leader Mission Trip?"
    },
    leaderSponsor: {
      table: "Trips",
      field: "leaderSponsor",
      fieldtype: "yesno",
      title: "Leader Sponsor Trip?"
    },
    disaster: {
      table: "Trips",
      field: "disaster",
      fieldtype: "yesno",
      title: "Disaster Relief"
    },
    transferredTripId: {
      table: "Trips",
      field: "transferredTripID",
      fieldtype: "text",
      title: "Transferred Trip ID"
    },
    active: {
      table: "Trips",
      field: "active",
      fieldtype: "noyes",
      title: "Deactivate Trip?"
    },
    dropReason: {
      table: "Trips",
      field: "dropReason",
      fieldtype: "text",
      title: "Drop Reason(s)"
    },
    locId: {
      table: "Trips",
      field: "locID",
      fieldtype: "rootsLocation",
      title: "Roots Destination"
    },
    tripDate: {
      table: "Trips",
      field: "tripdate",
      fieldtype: "date",
      title: "Trip Date"
    },
    duration: {
      table: "Trips",
      field: "duration",
      fieldtype: "text",
      title: "Duration"
    },
    accommodations: {
      table: "Trips",
      field: "accommodations",
      fieldtype: "text",
      title: "Accommodations"
    },
    groupingConfirmed: {
      table: "", //existing functionality in MC
      field: "groupingConfirmed",
      fieldtype: "confirmed",
      title: "Grouping"
    },
    grouping: {
      table: "Trips",
      field: "grouping",
      fieldtype: "text",
      title: "Grouping"
    },
    officeId: {
      table: "Trips",
      field: "officeID",
      fieldtype: "text",
      title: "PPM Office"
    },
    attendees: {
      table: "Trips",
      field: "attendees",
      fieldtype: "text",
      title: "Attendees"
    },
    airportConfirmed: {
      table: "",
      field: "airportConfirmed",
      fieldtype: "confirmed",
      title: "Airport",
    },
    airport: {
      table: "Trips",
      field: "airport",
      fieldtype: "text",
      title: "Airport"
    },
    driving: {
      table: "Trips",
      field: "driving",
      fieldtype: "yesno",
      title: "Driving?"
    },
    individual: {
      table: "Trips",
      field: "individual",
      fieldtype: "yesno",
      title: "Small Group"
    },
    newReg: {
      table: "Trips",
      field: "newreg",
      fieldtype: "yesno",
      title: "New trip?"
    },
    cutoff: {
      table: "Trips",
      field: "cutoff",
      fieldtype: "yesno",
      title: "Override 30-day Cutoff?"
    },
    recommendedJournal: {
      table: "Trips",
      field: "recommendedJournal",
      fieldtype: "yesno",
      title: "Recommended Journal?"
    },
    glJournals: {
      table: "Trips",
      field: "glJournals",
      fieldtype: "yesno",
      title: "Allow GL Journal Posts?"
    },
    consultingEmails: {
      table: "Trips",
      field: "consultingEmails",
      fieldtype: "yesno",
      title: "Send Automated Consulting Emails?"
    },
    salesId: {
      table: "Trips",
      field: "salesID",
      fieldtype: "staff",
      title: "Recruiter"
    },
    salesAssist: {
      table: "Trips",
      field: "salesassist",
      fieldtype: "staff",
      title: "Recruit Assist"
    },
    translatorConfirmed: {
      table: "Trips_sub",
      field: "translatorConfirmed",
      fieldtype: "confirmed",
      title: "Translator"
    },
    translator: {
      table: "Trips_sub",
      field: "translator",
      fieldtype: "text",
      title: "Translator"
    },
    consultPub: {
      table: "Trips",
      field: "consult_pub",
      fieldtype: "confirmed",
      title: "Consultant"
    },
    consultId: {
      table: "Trips",
      field: "consultID",
      fieldtype: "staff",
      title: "Consultant"
    },
    tlPub: {
      table: "Trips",
      field: "tl_pub",
      fieldtype: "confirmed",
      title: "Trip Leader"
    },
    staffId: {
      table: "Trips",
      field: "staffID",
      fieldtype: "staff",
      title: "Trip Leader"
    },
    atl1: {
      table: "Trips_sub",
      field: "atl1",
      fieldtype: "staff",
      title: "ATL #1"
    },
    atl1Confirmed: {
      table: "Trips_sub",
      field: "atl1Confirmed",
      fieldtype: "confirmed",
      title: "ATL #1"
    },
    atl2: {
      table: "Trips_sub",
      field: "atl2",
      fieldtype: "staff",
      title: "ATL #2"
    },
    atl2Confirmed: {
      table: "Trips_sub",
      field: "atl2Confirmed",
      fieldtype: "confirmed",
      title: "ATL #2"
    },
    atl3: {
      table: "Trips_sub",
      field: "atl3",
      fieldtype: "staff",
      title: "ATL #3"
    },
    atl3Confirmed: {
      table: "Trips_sub",
      field: "atl3Confirmed",
      fieldtype: "confirmed",
      title: "ATL #3"
    },
    atl4: {
      table: "Trips_sub",
      field: "atl4",
      fieldtype: "staff",
      title: "ATL #4"
    },
    atl4Confirmed: {
      table: "Trips_sub",
      field: "atl4Confirmed",
      fieldtype: "confirmed",
      title: "ATL #4"
    },
    atl5: {
      table: "Trips_sub",
      field: "atl5",
      fieldtype: "staff",
      title: "ATL #5"
    },
    atl5Confirmed: {
      table: "Trips_sub",
      field: "atl5Confirmed",
      fieldtype: "confirmed",
      title: "ATL #5"
    },
    atl6: {
      table: "Trips_sub",
      field: "atl6",
      fieldtype: "staff",
      title: "ATL #6"
    },
    atl6Confirmed: {
      table: "Trips_sub",
      field: "atl6Confirmed",
      fieldtype: "confirmed",
      title: "ATL #6"
    },
    atl7: {
      table: "Trips_sub",
      field: "atl7",
      fieldtype: "staff",
      title: "ATL #7"
    },
    atl7Confirmed: {
      table: "Trips_sub",
      field: "atl7Confirmed",
      fieldtype: "confirmed",
      title: "ATL #7"
    },
    atl8: {
      table: "Trips_sub",
      field: "atl8",
      fieldtype: "staff",
      title: "ATL #8"
    },
    atl8Confirmed: {
      table: "Trips_sub",
      field: "atl8Confirmed",
      fieldtype: "confirmed",
      title: "ATL #8"
    },
    atl9: {
      table: "Trips_sub",
      field: "atl9",
      fieldtype: "staff",
      title: "ATL #9"
    },
    atl9Confirmed: {
      table: "Trips_sub",
      field: "atl9Confirmed",
      fieldtype: "confirmed",
      title: "ATL #9"
    },
    atl10: {
      table: "Trips_sub",
      field: "atl10",
      fieldtype: "staff",
      title: "ATL #10"
    },
    atl10Confirmed: {
      table: "Trips_sub",
      field: "atl10Confirmed",
      fieldtype: "confirmed",
      title: "ATL #10"
    },
    atl11: {
      table: "Trips_sub",
      field: "atl11",
      fieldtype: "staff",
      title: "ATL #11"
    },
    atl11Confirmed: {
      table: "Trips_sub",
      field: "atl11Confirmed",
      fieldtype: "confirmed",
      title: "ATL #11"
    },
    atl12: {
      table: "Trips_sub",
      field: "atl12",
      fieldtype: "staff",
      title: "ATL #12"
    },
    atl12Confirmed: {
      table: "Trips_sub",
      field: "atl12Confirmed",
      fieldtype: "confirmed",
      title: "ATL #12"
    },
    atl13: {
      table: "Trips_sub",
      field: "atl13",
      fieldtype: "staff",
      title: "ATL #13"
    },
    atl13Confirmed: {
      table: "Trips_sub",
      field: "atl13Confirmed",
      fieldtype: "confirmed",
      title: "ATL #13"
    },
    atl14: {
      table: "Trips_sub",
      field: "atl14",
      fieldtype: "staff",
      title: "ATL #14"
    },
    atl14Confirmed: {
      table: "Trips_sub",
      field: "atl14Confirmed",
      fieldtype: "confirmed",
      title: "ATL #14"
    },
    atl15: {
      table: "Trips_sub",
      field: "atl15",
      fieldtype: "staff",
      title: "ATL #15"
    },
    atl15Confirmed: {
      table: "Trips_sub",
      field: "atl15Confirmed",
      fieldtype: "confirmed",
      title: "ATL #15"
    },
    atl16: {
      table: "Trips_sub",
      field: "atl16",
      fieldtype: "staff",
      title: "ATL #16"
    },
    atl16Confirmed: {
      table: "Trips_sub",
      field: "atl16Confirmed",
      fieldtype: "confirmed",
      title: "ATL #16"
    },
    minMoneyEst: {
      table: "Trips",
      field: "minmoneyest",
      fieldtype: "number",
      title: "Estimated Ministry Money"
    },
    ministryMoney: {
      table: "Trips",
      field: "ministrymoney",
      fieldtype: "number",
      title: "Confirmed Ministry Money"
    },
    mmLock: {
      table: "Trips",
      field: "mmlock",
      fieldtype: "yesno",
      title: "Lock Ministry Money?"
    },
    expenses: {
      table: "Trips",
      field: "expenses",
      fieldtype: "text",
      title: "Expense Report Link"
    },
    promo: {
      table: "Trips",
      field: "promo",
      fieldtype: "text",
      title: "Promo Code"
    },
    quickNote: {
      table: "Trips",
      field: "quicknote",
      fieldtype: "text",
      title: "Finance Quick Note"
    },
    quicknoteTimestamp: {
      table: "Trips",
      field: "quicknoteTimestamp",
      fieldtype: "date",
      title: "Finance Quick Note Timestamp"
    },
    quicknoteStaffId: {
      table: "Trips",
      field: "quicknoteStaffId",
      fieldtype: "staff",
      title: "Finance Quick Note Staff"
    },
    extendDonation: {
      table: "Trips",
      field: "extendDonation",
      fieldtype: "yesno",
      title: "Extend Donation Cutoff?"
    },
    noInvoice: {
      table: "Trips",
      field: "noinvoice",
      fieldtype: "yesno",
      title: "Do Not Invoice?"
    },
    inAbacus: {
      table: "Trips",
      field: "inAbacus",
      fieldtype: "yesno",
      title: "Trip ID in Abacus"
    },
    lodging: {
      table: "Trips_sub",
      field: "lodging",
      fieldtype: "text",
      title: "Lodging"
    },
    vehicle: {
      table: "Trips_sub",
      field: "vehicle",
      fieldtype: "text",
      title: "Vehicle"
    },
    vehicleConfirmed: {
      table: "Trips_sub",
      field: "vehicleConfirmed",
      fieldtype: "confirmed",
      title: "Vehicle"
    },
    recreation: {
      table: "Trips_sub",
      field: "recreation",
      fieldtype: "text",
      title: "Recreation"
    },
    recreationConfirmed: {
      table: "Trips_sub",
      field: "recreationConfirmed",
      fieldtype: "confirmed",
      title: "Recreation"
    },
    recLodging: {
      table: "Trips_sub",
      field: "recLodging",
      fieldtype: "text",
      title: "Rec Lodging"
    },
    recLodgingConfirmed: {
      table: "Trips_sub",
      field: "recLodgingConfirmed",
      fieldtype: "confirmed",
      title: "Recreation Lodging"
    },
    transportation: {
      table: "Trips_sub",
      field: "transportation",
      fieldtype: "text",
      title: "Transportation"
    },
    transportationConfirmed: {
      table: "Trips_sub",
      field: "transportationConfirmed",
      fieldtype: "confirmed",
      title: "Transportation"
    },
    meals: {
      table: "Trips_sub",
      field: "meals",
      fieldtype: "text",
      title: "Meals"
    },
    mealsConfirmed: {
      table: "Trips_sub",
      field: "mealsConfirmed",
      fieldtype: "confirmed",
      title: "Meals"
    },
    cost: {
      table: "Trips",
      field: "cost",
      fieldtype: "text",
      title: "Cost"
    },
    yc: {
      table: "Trips",
      field: "yc",
      fieldtype: "yesno",
      title: "Youth Cartel"
    },
    lastInvoiced: {
      table: "Trips",
      field: "lastInvoiced",
      fieldtype: "date",
      title: "Last Invoiced"
    },
    lodgingConfirmed: {
      table: "Trips_sub",
      field: "lodgingConfirmed",
      fieldtype: "confirmed",
      title: "Lodging"
    },
    designation: {
      table: "Trips",
      field: "designation",
      fieldtype: "number",
      title: "Designation"
    },
    backgroundCheckType: {
      table: "Trips",
      field: "backgroundCheckType",
      fieldtype: "number",
      title: "Default Background Check Type"
    },
    siteLeaderId: {
      table: "Trips",
      field: "siteLeaderId",
      fieldtype: "staff",
      title: "Site Leader"

    },
    siteLeaderConfirmed: {
      table: "Trips",
      field: "siteLeaderConfirmed",
      fieldtype: "confirmed",
      title: "Site Leader"
    }

  }


  getMcSubtripUpdateObject(subtripId: string, custId: number, tripData: Partial<TripsSub>) {



    let fieldKey: any
    // get the first key. Only.  Does not support updating multiple fields at a time
    for (const key in tripData) {
      if (fieldKey) {
        throw new Error("Only one subtrip field may be updated at a time")
      }
      if (Object.prototype.hasOwnProperty.call(tripData, key)) {
        fieldKey = key as any;
        break;

      }
    }

    const returnObj = { ...(this.fieldData as any)[fieldKey] }

    returnObj["id"] = subtripId;
    returnObj["custid"] = custId

    switch (returnObj["field"]) {
      case "tripdate":
        returnObj["value"] = DateTime.fromJSDate((tripData as any)[fieldKey] as Date).toFormat("yyyy-MM-dd")
        break;
      default:
        returnObj["value"] = (tripData as any)[fieldKey]
    }


    return this.convertToFormData(returnObj)
  }

  getMcTripUpdateObject(tripId: number, custId: number, tripData: Partial<Trip>) {

    let fieldKey: any
    //HACK  get the first key. Only.  Does not support updating multiple fields at a time
    for (const key in tripData) {
      if (fieldKey) {
        throw new Error("Only one trip field can be updated at a time")
      }
      if (Object.prototype.hasOwnProperty.call(tripData, key)) {
        fieldKey = key as any;
        break;

      }
    }

    const returnObj = { ...(this.fieldData as any)[fieldKey] }

    returnObj["id"] = tripId;
    returnObj["custid"] = custId

    switch (returnObj["field"]) {
      case "tripdate":
      case "lastInvoiced":
        returnObj["value"] = DateTime.fromJSDate((tripData as any)[fieldKey] as Date).toFormat("yyyy-MM-dd")
        break;
      default:
        returnObj["value"] = (tripData as any)[fieldKey]
    }


    return this.convertToFormData(returnObj)

  }


  convertToFormData(obj: any) {
    const formData = new FormData()

    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        formData.append(key, obj[key])

      }
    }

    return formData

  }

}
